<template>
	<div class="wrap wrap--products">
		<!-- 헤더 -->
		<main-header :header-type="'shop'"></main-header>

		<!-- 메인 -->
		<main class="main" role="main">
            <div class="inner">
                <div class="product-order-container">
					<!-- 페이지 타이틀 -->
                    <div class="order-title">
                        <h1 class="order-title__text">결제결과</h1>
                    </div>
                    <div v-if="order" class="purchase-title">
                        <div v-if="order.paymentStatus" class="img"><img src="/images/icon/check-graphic-round.png" alt=""></div>
						<div v-else class="img"><img src="/images/icon/caution-graphic.png" alt=""></div>
                        <h2 v-if="order.paymentStatus" class="purchase-title__text">결제가 완료 되었습니다.</h2>
						<h2 v-else class="purchase-title__text">결제에 실패했습니다.</h2>
                        <p v-if="order.paymentStatus" class="purchase-title__pr">이용해 주셔서 감사합니다.</p>
						<p v-else class="purchase-title__pr">[{{ order.paymentCode }}] {{ order.paymentMessage }}</p>
                    </div>
                    
					<!-- 페이지 버튼 -->
                    <div class="order-buttons">
                        <a v-if="success" class="button button--primary" href="/mypage/order-list"><span>주문내역 확인</span></a>
						<a e-else class="button button--primary" href="/"><span>확인</span></a>
                    </div>
                </div>
            </div>
		</main>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import MainHeader from "../../../components/client/inc/main-header.vue";
import MainFooter from "../../../components/client/inc/main-footer.vue";
import axios from "@/plugins/axios";

export default{
	components: {
		MainHeader,
		MainFooter
	},
	data() {
		return {			
			orderNo: this.$route.query.orderNo,
			order: null,
			success: false,
			message: null
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		async init() {
			try{
				// await this.verifyOrder();
				await this.getOrder();

				this.success = true;
			}
			catch(error){
				console.error(error);
				if(error.response) this.message = error.response.data.message;
			}
		},

		// verifyOrder(){
		// 	return new Promise(async (resolve, reject) => {
		// 		try{
		// 			var res = await this.$http.get('/api/v1/shop/orders/validate', {
		// 				params: this.$route.query
		// 			});

		// 			this.order = res.data.order;

		// 			resolve();
		// 		}
		// 		catch(error){
		// 			reject(error);
		// 		}
		// 	});
		// },

        getOrder() {
            return new Promise(async (resolve, reject) => {
                try {
                    const {
                        data: { orders },
                    } = await axios.get(`/api/v1/shop/orders/${this.orderNo}`);

                    this.order = orders.reduce((orders, order) => {
                        if (orders == undefined) {
                            const { _store, ...__order } = order;
                            return {
                                ...__order,
                                _stores: [_store],
                            };
                        } else {
                            orders._stores = [...orders._stores, order._store];
                            orders._pickups = [...orders._pickups, ...order._pickups];
                            orders._productCoupons = [...orders._productCoupons, ...order._productCoupons];
                            orders._deliveryCoupons = [...orders._deliveryCoupons, ...order._deliveryCoupons];

                            orders.totalSaleAmount += order.totalSaleAmount;
                            orders.totalDiscountAmount += order.totalDiscountAmount;
                            orders.totalDeliveryAmount += order.totalDeliveryAmount;
                            orders.totalIslandAmount += order.totalIslandAmount;
                            orders.totalCouponAmount += order.totalCouponAmount;
                            orders.totalPointAmount += order.totalPointAmount;
                            orders.totalOrderAmount += order.totalOrderAmount;

                            return orders;
                        }
                    }, undefined);

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
	},
	computed: {
		cartsMap(){
			var map = new Map();
			if(this.order){
				for(var i in this.order.purchases){
					var cart = this.order.purchases[i];
					var value = map.get(cart._product);
					if(value) value.carts.push(cart);
					else value = { product: cart.product, carts: [cart] };
					map.set(cart._product, value);
				}
			}
			return Array.from(map.values());
		}
	}
}
</script>
